import { actions } from "./actions";

export function getToggles(dispatch) {
    return {
        setReferralsSearch: payload => dispatch({ type: actions.SET_REFERRALS_SEARCH, payload: payload }),
        setLoading: payload => dispatch({ type: actions.SET_LOADING, payload: payload }),
    }
}